import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack} from 'views/components';

import predefinedOptionsConfigs from '../util/predefinedOptionsConfigs';

const PredefinedOptionsPane = (props) => {
  const {
    dueDate,
    handleSelectReminderDate,
  } = props;

  const [highlightedOptionIndex, setHighlightedOptionIndex] = React.useState(0);

  const rootRef = React.useRef(null);

  const handleSelectedOption = React.useCallback((selectedOption) => {
    const reminderDate = selectedOption.converter(dueDate);
    handleSelectReminderDate(reminderDate);
  }, [dueDate, handleSelectReminderDate]);

  React.useEffect(() => {
    rootRef.current?.focus({preventScroll: true});
  }, [rootRef]);

  const handleKeyDown = React.useCallback((event) => {
    const isHandledKey = [
      'ArrowDown',
      'ArrowUp',
      'Enter',
    ].includes(event.key);

    if (!isHandledKey) {
      return;
    }

    event.preventDefault();

    if (event.key === 'ArrowDown') {
      setHighlightedOptionIndex((previousIndex) => (previousIndex + 1) % predefinedOptionsConfigs.length);
      return;
    }

    if (event.key === 'ArrowUp') {
      setHighlightedOptionIndex((previousIndex) => (previousIndex - 1 + predefinedOptionsConfigs.length) % predefinedOptionsConfigs.length);
      return;
    }

    if (event.key === 'Enter') {
      const highlightedOption = predefinedOptionsConfigs[highlightedOptionIndex] || predefinedOptionsConfigs[0];

      if (highlightedOption) {
        handleSelectedOption(highlightedOption);
      }
    }
  }, [handleSelectedOption, highlightedOptionIndex, predefinedOptionsConfigs]);

  return (
    <Box
      ref={rootRef}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      sx={{
        overflowY: 'auto',
        maxHeight: 290,
        pr: 0.5,
      }}
    >
      <Stack spacing={0.25}>
        {
          predefinedOptionsConfigs.map((option, optionIndex) => (
            <Box
              key={option.key}
              component='button'
              onMouseEnter={() => setHighlightedOptionIndex(optionIndex)}
              onClick={() => handleSelectedOption(option)}
              sx={{
                background: 'none',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: optionIndex === highlightedOptionIndex ? '#F7F4EF' : 'transparent',
                width: '100%',
                textAlign: 'left',
                cursor: 'pointer',
                px: 0.75,
                py: 0.75,
                color: '#23201C',
                fontSize: '16px',
              }}
            >
              <Stack direction='row' justifyContent='space-between' spacing={2} sx={{width: '100%'}}>
                <Box component='span'>
                  {option.label}
                </Box>
                <Box component='span' sx={{color: '#919191'}}>
                  {option.code}
                </Box>
              </Stack>
            </Box>
          ))
        }
      </Stack>
    </Box>
  );
};

PredefinedOptionsPane.propTypes = {
  dueDate: PropTypes.string.isRequired,
  handleSelectReminderDate: PropTypes.func.isRequired,
};

export default React.memo(PredefinedOptionsPane);
